var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "650" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.toUseTitle))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: "btw-nummer" },
                        model: {
                          value: _vm.vatNumber,
                          callback: function ($$v) {
                            _vm.vatNumber = $$v
                          },
                          expression: "vatNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: "glnNumber" },
                        model: {
                          value: _vm.glnNumber,
                          callback: function ($$v) {
                            _vm.glnNumber = $$v
                          },
                          expression: "glnNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: "Enkel versturen" },
                        model: {
                          value: _vm.sendOnly,
                          callback: function ($$v) {
                            _vm.sendOnly = $$v
                          },
                          expression: "sendOnly",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v("Annuleren")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    icon: "check",
                    disabled: !_vm.isValid || _vm.isSaving,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v("Bevestigen")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }